import { useEffect, useRef } from "react";

export function useEventListener<F = EventListener>(
  eventName: string,
  handler: F,
  element: Element | Document | Window = window,
  options?: boolean | AddEventListenerOptions
) {
  // Create a ref that stores handler
  const savedHandler = useRef<F>(handler);

  // Update ref.current value if handler changes.
  // This allows our effect below to always get latest handler ...
  // ... without us needing to pass it in effect deps array ...
  // ... and potentially cause effect to re-run every render.
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(
    () => {
      // Make sure element supports addEventListener
      // On
      const isSupported = element && element.addEventListener;
      if (!isSupported) return;
      //@ts-ignore Create event listener that calls handler function stored in ref
      const eventListener = (event: Event) => savedHandler.current(event);
      element.addEventListener(eventName, eventListener, options);
      return () => {
        element.removeEventListener(eventName, eventListener);
      };
    },
    [eventName, element, options] // Re-run if eventName or element changes
  );
}
